import { useState, useEffect } from 'react';
import {
  Box,
  Checkbox,
  Divider,
  Grid,
  Typography,
  TextField,
  Paper,
  IconButton,
  Button,
  Menu,
  MenuItem,
  Link as MuiLink,
  ListItemIcon,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Snackbar,
  Modal
} from "@mui/material";

import { styled } from '@mui/material/styles';

import { Formik } from 'formik';
import axios from  'axios';
import { blueGrey } from '@mui/material/colors';
import jwtDecode from 'jwt-decode';

import {
  Search,
  Notifications,
  ShoppingCart,
  Email,
  LocalAtm,
  ExitToApp,
  PowerOffRounded
} from "@material-ui/icons";

import SearchIcon from '@mui/icons-material/Search';
import styledComponent from "styled-components";
import { Link, useNavigate } from "react-router-dom";
import mainLogo from '../../assets/logo.png';
import MenuIcon from '@mui/icons-material/Menu';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import DeleteIcon from '@mui/icons-material/Delete';
import AddIcon from '@mui/icons-material/Add';
import RemoveIcon from '@mui/icons-material/Remove';

import MuiAlert from '@mui/material/Alert';
import { tableCellClasses } from '@mui/material/TableCell';
import ProductionQuantityLimitsIcon from '@mui/icons-material/ProductionQuantityLimits';

const modalStyle = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: { xs: '80%', md: 400 },
  maxHeight: '68vh',
  bgcolor: 'background.paper',
  boxShadow: 24,
  p: 4,
  overflow: 'scroll'
};

const StyledTableCell = styled(TableCell)(({ theme }) => ({
[`&.${tableCellClasses.head}`]: {
  color: theme.palette.common.black
},
[`&.${tableCellClasses.body}`]: {
  fontSize: 14,
},
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
'&:nth-of-type(odd)': {
  backgroundColor: theme.palette.action.hover,
},
// hide last border
'&:last-child td, &:last-child th': {
  border: 0,
},
}));

const Container = styledComponent.div`
  height: 70px;
  background-color: #c9d0d4;
`;

const Wrapper = styledComponent.div`
  padding: 10px 20px;
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

const CartItem = styledComponent.div`
  position: absolute;
  color: white;
  padding: 1px 4px;
  margin-left: -9px;
  margin-top: -9px;
  border-radius: 30%;
  background-color: red;
  opacity: 0.9;
`;

const verifyToken = (serviceToken) => {
  if (!serviceToken) {
      return false;
  }
  const decoded = jwtDecode(serviceToken);
  /**
   * Property 'exp' does not exist on type '<T = unknown>(token: string, options?: JwtDecodeOptions | undefined) => T'.
   */
  return decoded.exp > Date.now() / 1000;
};

const NavbarTransaksi = () => {
    const [cart, setCart] = useState([]);
    const navigate = useNavigate();
    const [anchorEl, setAnchorEl] = useState(null);
    const open = Boolean(anchorEl);

    const handleClickMenu = (event) => {
      setAnchorEl(event.currentTarget);
    };
    const handleCloseMenu = () => {
      setAnchorEl(null);
    };
    const handleLogout = () => {
      localStorage.removeItem('token');
      navigate('/');
    }

    const [token, setToken] = useState(
      JSON.parse(localStorage.getItem('token')) !== null ? 
          JSON.parse(localStorage.getItem('token')).token :
          null
    );

    const [saldoData, setSaldoData] = useState(0);
  
    useEffect(() => {
      const getCart = async () => {
        try {
          const cartData = await axios.get(`${process.env.REACT_APP_API_URL}/api/dashboard/cart/list`, {
            headers: {
              Authorization: `Bearer ${JSON.parse(localStorage.getItem('token')).token}`
            }
          });

          let jmlQ = 0;
          let totalH = 0;

          setCart(cartData.data.result);
          
          cartData.data.result.forEach((item) => {
            jmlQ += item.jmlh;
            totalH += item.subtotal;
          });

          UpdatedJmlState(jmlQ);
          UpdatedTotalState(totalH);

        } catch (err) {
          console.log(err);
        }
      };
      const getSaldo = async () => {
        try {
            const saldo = await axios.get(`${process.env.REACT_APP_API_URL}/api/dashboard/saldo`, {
                headers: {
                    Authorization: `Bearer ${JSON.parse(localStorage.getItem('token')).token}`
                }
            });
            let debitData = 0;
            let creditData = 0;
            saldo.data.result.forEach((v) => {
                debitData += v.debit;
                creditData += v.credit;
            });
            setSaldoData(debitData - creditData);
        } catch (err) {
            console.log(err);
        }
      };

      if(verifyToken(token)){
        getCart();
      }
    }, [])

    return (
        <Container>
            <Wrapper>
                <Grid container spacing={0}>
                  <Grid item xs={8} md={8} sx={{ display: 'flex', margin: 'auto' }}>
                    <Grid container spacing={1}>
                      <Grid item xs={1} sm={2} md={3} display="flex">
                        <Grid container direction="column" display="flex" justifyContent="center">
                          {window.location.pathname.split('/').length > 2 && (
                            <Grid item xs={2}>
                              <ArrowBackIosIcon onClick={() => history.back()} />
                            </Grid>
                          )}
                          <Grid
                            item
                            xs={10}
                            sx={{ display: {xs: 'none', sm: 'block', md: 'block'} }}
                          >
                            <img
                              src={mainLogo}
                              width="50%"
                            />
                          </Grid>
                        </Grid>
                      </Grid>
                    </Grid>
                  </Grid>

                  <Grid
                    item
                    md={4}
                    sx={{
                      display: { xs: 'none', md: 'flex', margin: 'auto' }
                    }}
                  >
                    <Grid container spacing={3} justifyContent="flex-end">
                      <Grid item direction="column" flexDirection="column">
                        <Grid container spacing={1}>
                          <Grid item><LocalAtm /></Grid>
                          <Grid item>
                            <Box sx={{
                              backgroundColor: 'white',
                              '&:hover': {
                                cursor: 'pointer'
                              },
                              padding: '1px 7px',
                              borderRadius: '5px'
                            }}>
                              <Link
                                to="/dashboard/saldo"
                                style={{
                                  textDecoration: 'none',
                                  display: 'flex',
                                  alignItems: 'center',
                                  color: 'grey',
                                  '&:hover': {
                                    color: '#000'
                                  }
                                }}
                              >
                                <Typography
                                  variant="subtitle2"
                                  style={{ fontWeight: 700 }}
                                >
                                  {/* Rp. 21.000.000 */}
                                  Rp. {saldoData.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")}
                                </Typography>
                              </Link>
                            </Box>
                          </Grid>
                        </Grid>
                      </Grid>
                      <Grid item>
                        <ShoppingCart
                          style={{
                            cursor: 'pointer'
                          }}
                        />
                      </Grid>
                      <Grid item>
                        <Email
                          style={{
                            cursor: 'pointer'
                          }}
                        />
                      </Grid>
                      <Grid item>
                        <Notifications
                          style={{
                            cursor: 'pointer'
                          }}
                        />
                      </Grid>
                      <Grid item>
                        <ExitToApp
                          onClick={handleLogout}
                          style={{
                            cursor: 'pointer'
                          }}
                        />
                      </Grid>
                    </Grid>
                  </Grid>
                  <Grid
                    item
                    xs={2}
                    sm={2}
                    sx={{
                      display: { xs: 'flex', md: 'none' },
                      alignItems: 'center',
                      textAlign: 'center'
                    }}
                  >
                    <Box sx={{ display: 'flex', alignItems: 'center', textAlign: 'center' }}>
                      <IconButton
                        onClick={handleClickMenu}
                        size="small"
                        sx={{ ml: 2 }}
                        aria-controls={open ? 'account-menu' : undefined}
                        aria-haspopup="true"
                        aria-expanded={open ? 'true' : undefined}
                      >
                        <MenuIcon sx={{ fontSize: '44px' }}/>
                      </IconButton>
                    </Box>
                  </Grid>
                  <Menu
                    anchorEl={anchorEl}
                    id="account-menu"
                    open={open}
                    onClose={handleCloseMenu}
                    onClick={handleCloseMenu}
                    PaperProps={{
                      elevation: 0,
                      sx: {
                        width: { xs: '70%', sm: '50%' },
                        overflow: 'visible',
                        filter: 'drop-shadow(0px 2px 8px rgba(0,0,0,0.32))',
                        mt: 1.5,
                        '& .MuiAvatar-root': {
                          width: 32,
                          height: 32,
                          ml: -0.5,
                          mr: 1,
                        },
                        '&:before': {
                          content: '""',
                          display: 'block',
                          position: 'absolute',
                          top: 0,
                          right: 14,
                          width: 10,
                          height: 10,
                          bgcolor: 'background.paper',
                          transform: 'translateY(-50%) rotate(45deg)',
                          zIndex: 0,
                        },
                      },
                    }}
                    transformOrigin={{ horizontal: 'right', vertical: 'top' }}
                    anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
                  >
                    <MenuItem>
                      <Link
                        to="/dashboard/saldo"
                        style={{
                          textDecoration: 'none',
                          display: 'flex',
                          alignItems: 'center',
                          color: '#4d5869',
                          '&:hover': {
                            color: '#000'
                          }
                        }}
                      >
                        <LocalAtm /> &nbsp; Rp. {saldoData.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")}
                      </Link>
                    </MenuItem>
                    <MenuItem>
                      <Email /> &nbsp; Message
                    </MenuItem>
                    <MenuItem>
                      <Notifications /> &nbsp; Notifications
                    </MenuItem>
                    <Divider />
                    <MenuItem onClick={handleLogout}>
                      <ListItemIcon>
                        <ExitToApp fontSize="small" />
                      </ListItemIcon>
                      Logout
                    </MenuItem>
                  </Menu>
                </Grid>  
            </Wrapper>
        </Container>
    )
}

export default NavbarTransaksi
